<template>
	<div class="icon-profile">
		<svg
			width="24.000000"
			height="24.000000"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlns:xlink="http://www.w3.org/1999/xlink"
		>
			<desc>Created with Pixso.</desc>
			<defs>
				<clipPath id="clip85_1492">
					<rect
						id="search"
						width="24.000000"
						height="24.000000"
						fill="white"
						fill-opacity="0"
					/>
				</clipPath>
			</defs>
			<g clip-path="url(#clip85_1492)">
				<path
					id="Слияние"
					d="M16.1899 2L7.81006 2C4.17004 2 2 4.16992 2 7.81006L2 16.1899C2 19 3.29004 20.9299 5.56006 21.6599C6.21997 21.8899 6.97998 22 7.81006 22L16.1899 22C17.02 22 17.78 21.8899 18.4399 21.6599C20.71 20.9299 22 19 22 16.1899L22 7.81006C22 4.16992 19.83 2 16.1899 2ZM20.5 16.1899C20.5 18.3301 19.66 19.6799 17.97 20.24C17 18.3301 14.7 16.97 12 16.97C9.30005 16.97 7.01001 18.3201 6.03003 20.24C4.35999 19.7 3.5 18.3401 3.5 16.2L3.5 7.81006C3.5 4.98999 4.98999 3.5 7.81006 3.5L16.1899 3.5C19.01 3.5 20.5 4.98999 20.5 7.81006L20.5 16.1899ZM8.42188 11.5801C8.42188 9.6001 10.0219 8 12.002 8C13.9819 8 15.5819 9.6001 15.5819 11.5801C15.5819 13.5601 13.9819 15.1699 12.002 15.1699C10.0219 15.1699 8.42188 13.5601 8.42188 11.5801Z"
					clip-rule="evenodd"
					fill="#FFFFFF"
					fill-opacity="1.000000"
					fill-rule="evenodd"
				/>
			</g>
		</svg>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";

@Options({})
export default class IconProfile extends Vue {}
</script>

<style scoped lang="scss">
.icon-profile {
	display: flex;
}
</style>
